module.exports = __webpack_public_path__ + "img/icon_lvjing_huidiao_hover@2x.9f9a17b1.png";